import React from 'react';
import Card from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { Link } from 'react-router-dom'

import CardIcon from './CardIcon';

const styles = {
    main: {
        flex: '1',
        marginLeft: '1em',
        marginTop: 20,
    },
    card: {
        overflow: 'inherit',
        textAlign: 'right',
        padding: 16,
        minHeight: 52,
        width : 'auto'
    },
};

const getIcon = (type) => {
    switch(type){
        case 'subestaciones':
            return 'subestacion'
        case 'lineas':
            return 'linea'
        default:
            return ''
    }
}

const TotalInstalationWidget = ({ 
    data : { name, total, path }, 
    classes 
}) => (
    <div className={classes.main}>
        <CardIcon iconName={getIcon(path)} bgColor="#34C280" />
        <Card className={classes.card}>
            <Typography className={classes.title} color="textSecondary" component={Link} to={{pathname: `/${path}`}}>
                {name}
            </Typography>
            <Typography variant="headline" component="h2">
                {total}
            </Typography>
        </Card>
    </div>
);



export default withStyles(styles)(TotalInstalationWidget)